export const infographics = [
    {
        img: 'cartonboard-straight-tuck-end--infographic.jpg',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'straight-tuck-end'
        }
    },
    {
        img: 'corrugated--210--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-210'
        }
    },
    {
        img: 'corrugated--211--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-211'
        }
    },
    {
        img: 'corrugated--215--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-215'
        }
    },
    {
        img: 'corrugated--330--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-330'
        }
    },
    {
        img: 'corrugated--426--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-426'
        }
    },
    {
        img: 'corrugated--703--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-703'
        }
    },
    {
        img: 'corrugated--711--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-711'
        }
    },
    {
        img: 'corrugated--713--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'fefco-713'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--3d-bottom-block-bottom--infographic.png',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': '3d-bottom-block-bottom'
        }
    },
    {
        img: 'rigid-box--clamshell--infographic.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'clamshell'
        }
    },
    {
        img: 'bags--chalk-bags--infographic.png',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'chalk-bag'
        }
    },
    {
        img: 'bags--paper-bags--infographic.png',
        requirements: {
            type__name: 'bags',
            'structural-design__code': 'paper-bag'
        }
    },
    {
        img: 'cartonboard--drawer-box--inographic.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'drawer-box'
        }
    },
    {
        img: 'cartonboard--two-piece--infographic.png',
        requirements: {
            type__name: 'cartonboard',
            'structural-design__code': 'two-piece'
        }
    },
    {
        img: 'corrugated--mailer-box--infographic.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'mailer-box-fefco-427'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--classic--infographic.png',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': 'classic'
        }
    },
    {
        img: 'envelopes-classic-3d-jiffy--jiffy-bag--infographic.png',
        requirements: {
            type__name: 'envelopes-classic-3d-jiffy',
            'structural-design__code': 'jiffy-bag'
        }
    },
    {
        img: 'envelopes-courier--courier--infographic.png',
        requirements: {
            type__name: 'envelopes-courier',
            'structural-design__code': 'courier'
        }
    },
    {
        img: 'paper-tubes--standard-tube--infographic.png',
        requirements: {
            type__name: 'paper-tubes',
            'structural-design__code': 'standard-tube'
        }
    },
    {
        img: 'poly-mailers--bio-poly-mailer--infographic.png',
        requirements: {
            type__name: 'poly-mailers',
            'structural-design__code': 'bio-poly-mailer'
        }
    },
    {
        img: 'poly-mailers--classic-poly-mailer--infographic.png',
        requirements: {
            type__name: 'poly-mailers',
            'structural-design__code': 'classic-poly-mailer'
        }
    },
    {
        img: 'rigid-box--drawer--infographic.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'drawer'
        }
    },
    {
        img: 'rigid-box--lid-and-bottom--infographic.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'lid-and-bottom'
        }
    },
    {
        img: 'rigid-box--magnetic--infographic.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'magnetic'
        }
    },
    {
        img: 'tapes--tape--infographic.png',
        requirements: {
            type__name: 'tapes',
            'structural-design__code': 'tape'
        }
    },
    {
        img: 'tissue--tissue--infographic.png',
        requirements: {
            type__name: 'tissue',
            'structural-design__code': 'tissue'
        }
    },
    {
        img: 'corrugated—xxx8-mailer-box—photo-2.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx8-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx1-mailer-box—photo-2.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx1-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx3-mailer-box—photo-2.jpg',
        requirements: {
            type__name: 'corrugated.jpg',
            'structural-design__code': 'xxx3-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx4-mailer-box—photo-2.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx4-mailer-box-fefco-427'
        }
    },
    {
        img: 'corrugated—xxx10-mailer-box—photo-2.png',
        requirements: {
            type__name: 'corrugated',
            'structural-design__code': 'xxx10-mailer-box-fefco-427'
        }
    },
    {
        img: 'rigid-box—rrr1-lid-and-bottom—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr1-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrr4-lid-and-bottom—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrr4-lid-and-bottom'
        }
    },
    {
        img: 'rigid-box—rrt1-drawer—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt1-drawer'
        }
    },
    {
        img: 'rigid-box—rrt2-drawer—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt2-drawer'
        }
    },
    {
        img: 'rigid-box—rrt6-drawer—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrt6-drawer'
        }
    },
    {
        img: 'rigid-box—rrw1-magnetic—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw1-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw2-magnetic—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw2-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw3-magnetic—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw3-magnetic'
        }
    },
    {
        img: 'rigid-box—rrw4-magnetic—photo-2.png',
        requirements: {
            type__name: 'rigid-box',
            'structural-design__code': 'rrw4-magnetic'
        }
    }
];
//# sourceMappingURL=infographics.js.map